import React from 'react';
import Grid from '@material-ui/core/Grid';
import CloseIcon from '@material-ui/icons/Close'
import PeopleIcon from '@material-ui/icons/People'

import CardStats from 'components/argon/Cards/Dashboard/CardStats.js'

const CompareInsuranceTotals = ( props ) => {

    const totals = props.totals

    return (
        <Grid container direction='row' spacing={1} style={{marginBottom: '2rem'}}>
            <Grid item xs={12} md={6}>
                <CardStats
                    subtitle='Leads (All Valid)'
                    title={props.leads.length}
                    icon={PeopleIcon}
                    color='bgPrimary'
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <CardStats
                    subtitle='Rejected'
                    title={totals.rejected}
                    icon={CloseIcon}
                    color='bgError'
                />
            </Grid>
        </Grid>
    )
}

export default CompareInsuranceTotals